import { produce } from 'immer'
import {
  ActiveChartEnum,
  LiquidityPrPeriodEnum,
} from 'shared/models/KeyFigures'
import {
  KEY_FIGURES_ACCOUNTS_REQUESTED,
  KEY_FIGURES_LOANS_REQUESTED,
  KEY_FIGURES_JOINTCOSTS_REQUESTED,
  KEY_FIGURES_JOINTCOSTS_SUCCESS,
  KEY_FIGURES_ACCOUNTS_SUCCESS,
  KEY_FIGURES_LOANS_SUCCESS,
  KEY_FIGURES_ACCOUNTS_FAILED,
  KEY_FIGURES_LOANS_FAILED,
  KEY_FIGURES_JOINTCOSTS_FAILED,
  KEY_FIGURES_LIQUIDITY_FAILED,
  KEY_FIGURES_LIQUIDITY_REQUESTED,
  KEY_FIGURES_LIQUIDITY_SUCCESS,
  KEY_FIGURES_UNPAIDINVOICES_SUCCESS,
  KEY_FIGURES_UNPAIDINVOICES_REQUESTED,
  KEY_FIGURES_UNPAIDINVOICES_FAILED,
  KEY_FIGURES_OPERATINGCOSTS_REQUESTED,
  KEY_FIGURES_OPERATINGCOSTS_SUCCESS,
  KEY_FIGURES_OPERATINGCOSTS_FAILED,
  KEY_FIGURES_RESULTS_REQUESTED,
  KEY_FIGURES_RESULTS_SUCCESS,
  KEY_FIGURES_RESULTS_FAILED,
  KEY_FIGURES_SET_ACTIVECHART_SUCCESS,
  KEY_FIGURES_SET_ACTIVECHART_REQUESTED,
  KEY_FIGURES_SET_LIQUIDITY_PERIOD,
  KEY_FIGURES_SET_CHART_YEAR,
  KEY_FIGURES_SET_CASHFLOW_ENABLED,
  KEY_FIGURES_FETCH_CASHFLOW_REQUESTED,
  KEY_FIGURES_FETCH_CASHFLOW_SUCCESS,
  KEY_FIGURES_FETCH_CASHFLOW_FAILED,
  KEY_FIGURES_CASHFLOW_RESET,
  KEY_FIGURES_REPORTS_REQUESTED,
  KEY_FIGURES_REPORTS_SUCCESS,
  KEY_FIGURES_REPORTS_FAILED,
} from './actionTypes'
import { KeyFiguresActionTypes } from './types'

const initialState = {
  loans: {
    data: [],
    loading: false,
    error: null,
  },
  reports: {
    data: [],
    loading: false,
    error: null,
  },
  accounts: {
    data: [],
    loading: false,
    error: null,
    cancelToken: null,
  },
  liquidity: {
    data: [],
    loading: false,
    error: null,
  },
  jointcosts: {
    data: [],
    loading: false,
    error: null,
  },
  operatingcosts: {
    data: [],
    loading: false,
    error: null,
  },
  unpaidInvoices: {
    data: [],
    loading: false,
    error: null,
  },
  results: {
    data: [],
    loading: false,
    error: null,
  },
  activeChart: {
    chart: ActiveChartEnum.Results,
    year: new Date().getFullYear(),
  },
  liquidityPrPeriod: {
    period: LiquidityPrPeriodEnum.Today,
  },
  cashflow: {
    enabled: null as boolean | null,
    data: null,
    loading: false,
    error: null as string | null,
  },
}

const reducer = produce(
  (state = initialState, action: KeyFiguresActionTypes) => {
    switch (action.type) {
      case KEY_FIGURES_ACCOUNTS_REQUESTED:
        state.accounts.error = null
        state.accounts.loading = true
        state.accounts.cancelToken = action.payload.cancelToken
        return

      case KEY_FIGURES_LOANS_REQUESTED:
        state.loans.error = null
        state.loans.loading = true
        return

      case KEY_FIGURES_REPORTS_REQUESTED:
        state.reports.error = null
        state.reports.loading = true
        return

      case KEY_FIGURES_OPERATINGCOSTS_REQUESTED:
        state.operatingcosts.error = null
        state.operatingcosts.loading = true
        return

      case KEY_FIGURES_JOINTCOSTS_REQUESTED:
        state.jointcosts.error = null
        state.jointcosts.loading = true
        return

      case KEY_FIGURES_JOINTCOSTS_SUCCESS:
        state.jointcosts.data = action.payload
        state.jointcosts.loading = false
        return

      case KEY_FIGURES_LIQUIDITY_REQUESTED:
        state.liquidity.error = null
        state.liquidity.loading = true
        return

      case KEY_FIGURES_UNPAIDINVOICES_REQUESTED:
        state.unpaidInvoices.error = null
        state.unpaidInvoices.loading = true
        return

      case KEY_FIGURES_RESULTS_REQUESTED:
        state.results.error = null
        state.results.loading = true
        return

      case KEY_FIGURES_SET_ACTIVECHART_REQUESTED:
        state.activeChart = { ...state.activeChart }
        return

      case KEY_FIGURES_SET_LIQUIDITY_PERIOD:
        state.liquidityPrPeriod.period = action.payload
        return

      case KEY_FIGURES_ACCOUNTS_SUCCESS:
        state.accounts.data = action.payload
        state.accounts.cancelToken = null
        state.accounts.loading = false
        return

      case KEY_FIGURES_OPERATINGCOSTS_SUCCESS:
        state.operatingcosts.data = action.payload
        state.operatingcosts.loading = false
        return

      case KEY_FIGURES_LOANS_SUCCESS:
        state.loans.data = action.payload
        state.loans.loading = false
        return

      case KEY_FIGURES_REPORTS_SUCCESS:
        state.reports.data = action.payload
        state.reports.loading = false
        return

      case KEY_FIGURES_LIQUIDITY_SUCCESS:
        state.liquidity.data = action.payload
        state.liquidity.loading = false
        return

      case KEY_FIGURES_UNPAIDINVOICES_SUCCESS:
        state.unpaidInvoices.data = action.payload
        state.unpaidInvoices.loading = false
        return

      case KEY_FIGURES_RESULTS_SUCCESS:
        state.results.data = action.payload
        state.results.loading = false
        return

      case KEY_FIGURES_SET_ACTIVECHART_SUCCESS:
        state.activeChart.chart = action.payload
        return

      case KEY_FIGURES_SET_CHART_YEAR:
        state.activeChart.year = action.payload
        return

      case KEY_FIGURES_ACCOUNTS_FAILED:
        state.accounts.error = action.payload
        state.accounts.loading = false
        return

      case KEY_FIGURES_LOANS_FAILED:
        state.loans.error = action.payload
        state.loans.loading = false
        return

      case KEY_FIGURES_REPORTS_FAILED:
        state.reports.error = action.payload
        state.reports.loading = false
        return

      case KEY_FIGURES_LIQUIDITY_FAILED:
        state.liquidity.error = action.payload
        state.liquidity.loading = false
        return

      case KEY_FIGURES_OPERATINGCOSTS_FAILED:
        state.operatingcosts.error = action.payload
        state.operatingcosts.loading = false
        return

      case KEY_FIGURES_JOINTCOSTS_FAILED:
        state.jointcosts.error = action.payload
        state.jointcosts.loading = false
        return

      case KEY_FIGURES_UNPAIDINVOICES_FAILED:
        state.unpaidInvoices.error = action.payload
        state.unpaidInvoices.loading = false
        return

      case KEY_FIGURES_RESULTS_FAILED:
        state.unpaidInvoices.error = action.payload
        state.unpaidInvoices.loading = false
        return

      case KEY_FIGURES_SET_CASHFLOW_ENABLED:
        state.cashflow.enabled = action.payload
        return

      case KEY_FIGURES_FETCH_CASHFLOW_REQUESTED:
        state.cashflow.loading = true
        return

      case KEY_FIGURES_FETCH_CASHFLOW_SUCCESS:
        state.cashflow.data = action.payload
        state.cashflow.loading = false
        return

      case KEY_FIGURES_FETCH_CASHFLOW_FAILED:
        state.cashflow.error = action.payload
        state.cashflow.loading = false
        state.cashflow.data = null
        return

      case KEY_FIGURES_CASHFLOW_RESET:
        state.cashflow.data = null
        state.cashflow.loading = false
        state.cashflow.error = null
        state.cashflow.enabled = null
        return

      default:
        return state
    }
  }
)

export default reducer
